import styled, {
  keyframes,
} from 'styled-components';
import {
  ToastContainer,
} from 'react-toastify';

import {
  icons,
} from 'web-styled';

const bounceInRight = keyframes`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0); }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0); }
  75% {
    transform: translate3d(10px, 0, 0); }
  90% {
    transform: translate3d(-5px, 0, 0); }
  to {
    transform: none; }
`;

const bounceOutRight = keyframes`
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0); }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0); }
`;
const trackProgress = keyframes`
  0% {
    transform: scaleX(1); }
  100% {
    transform: scaleX(0); }
`;

export const ToastifyContainer = styled(ToastContainer).attrs({
  position: 'bottom-right',
  autoClose: 5000,
  draggable: false,
  newestOnTop: true,
  hideProgressBar: true,
})`
  color: #808080;
  width: 300px;
  padding: 4px;
  position: fixed;
  box-sizing: border-box;
  z-index: 9999999999999;
  -webkit-transform: translate3d(0, 0, 9999px);

  &.Toastify__toast-container--bottom-right {
    bottom: 1em;
    right: 1em;
  }

  @media only screen and (max-width: 480px) {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;

    &.Toastify__toast-container--bottom-right {
      bottom: 0;
      transform: translateX(0);
    }
  }

  .Toastify__toast {
    position: relative;
    min-height: 64px;
    box-sizing: border-box;
    margin-bottom: 1rem;
    padding: 8px;
    padding-left: 0;
    background: #fff;
    border-radius: 3px;
    border-left-width: 5px;
    border-left-style: solid;
    box-shadow: 0 0 5px 0 #999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-height: 800px;
    overflow: hidden;
    font-size: 15px;
    font-family: 'Source Sans Pro', sans-serif;
    cursor: pointer;
    direction: ltr;
  }

  .Toastify__toast:before,
  .Toastify__toast:after {
    content: '';
    display: inline-block;
    flex-shrink: 0;
  }

  .Toastify__toast:before {
    width: 25px;
    height: 25px;
    border-radius: 25px;
    margin: 8px 12px;
  }

  .Toastify__toast:after {
    width: 18px;
    height: 18px;
    position: absolute;
    left: 16px;
    top: 20px;
  }

  .Toastify__toast--default {
    border-color: #808080;
  }

  .Toastify__toast--default:before {
    background: #808080 url(${icons.exercises});
    background-size: cover;
  }

  .Toastify__toast--warning {
    border-color: ${props => props.theme.colors.warning};
  }

  .Toastify__toast--warning:before {
    background: ${props => props.theme.colors.warning} url(${icons.warningIcon}) no-repeat center;
    background-size: 11px;
  }

  .Toastify__toast--success {
    border-color: ${props => props.theme.colors.success};
  }

  .Toastify__toast--success:before {
    background: ${props => props.theme.colors.success} url(${icons.exercises});
    background-size: cover;
  }
  .Toastify__toast--info {
    border-color: ${props => props.theme.colors.primary};
  }

  .Toastify__toast--info:before {
    background: ${props => props.theme.colors.primary} url(${icons.warningIcon}) no-repeat center;
    background-size: 11px;
  }

  .Toastify__toast--error {
    border-color: ${props => props.theme.colors.danger};
  }

  .Toastify__toast--error:before {
    content: 'x';
    color: #fff;
    font-size: 15px;
    text-align: center;
    background: ${props => props.theme.colors.danger};
  }

  .Toastify__toast-body {
    margin: auto 0;
    flex: 1 1 auto;
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast {
      margin-bottom: 6px;
    }
  }

  .Toastify__close-button {
    color: #808080;
    font-size: 13px;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    align-self: flex-start;

    & > svg {
      fill: #666;
      height: 16px;
      width: 14px;
    }
  }

  .Toastify__close-button--default {
    color: #000;
    opacity: 0.3;
  }

  .Toastify__close-button:hover,
  .Toastify__close-button:focus {
    opacity: 1;
  }

  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: 9999;
    opacity: 0.7;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left;
  }
  .Toastify__progress-bar--animated {
    animation: ${trackProgress} linear 1 forwards;
  }
  .Toastify__progress-bar--controlled {
    transition: transform 0.2s;
  }
  .Toastify__progress-bar--rtl {
    right: 0;
    left: initial;
    transform-origin: right;
  }
  .Toastify__progress-bar--default {
    background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  }
  .Toastify__progress-bar--dark {
    background: #bb86fc;
  }

  .Toastify__bounce-enter--bottom-right {
    animation-name: ${bounceInRight};
  }
  .Toastify__bounce-exit--bottom-right {
    animation-name: ${bounceOutRight};
  }
`;
